import { Link } from 'react-router-dom';

const cards = [
  {
    to: '/welcome',
    title: 'Welcome landing',
    desc: 'Full first-visit page — CTA and scrolling edition cards',
  },
  {
    to: '/admin/dev/prompts',
    title: 'Prompts',
    desc: 'Edit pipeline prompts and version history',
  },
  {
    to: '/admin/dev/sources',
    title: 'Sources',
    desc: 'Manage the news source list',
  },
  {
    to: '/admin/dev/runs',
    title: 'Runs',
    desc: 'Trigger pipeline runs and view history',
  },
  {
    to: '/admin/dev/feedback',
    title: 'Feedback',
    desc: 'Editor notes, problem reports, and per-article feedback',
  },
];

export default function DevLanding() {
  return (
    <div className="max-w-page mx-auto px-4 sm:px-6 py-8">
      <h1 className="hxd-page-title">Dev Dashboard</h1>
      <p className="hxd-page-subtitle">Internal control plane for the editorial pipeline.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ to, title, desc }) => (
          <Link
            key={to}
            to={to}
            className="hxd-card block hover:border-hxd-orange transition-colors no-underline group"
          >
            <div className="font-display text-[11px] font-bold tracking-display-md uppercase text-hxd-orange mb-2">
              {title}
            </div>
            <div className="text-[13px] text-hxd-muted">{desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
